import React from "react";
import { Helmet } from "react-helmet";
import favicon from '~image/favicon.png';
import Header from "../Header";
export default function Layout({
  children,
}) {
  return (
    <>
    <Helmet>
          <title>Nextgen</title>
          <link rel="icon" type="image/jpg" href={favicon} />
    </Helmet>
      <Header/>
      {children}
    </>
  )
}
